import React, { useContext } from 'react';
import { Column } from '../components/shared/Column';
import { Grid } from '../components/shared/Grid';

import { BaseLayout } from '../components/template/BaseLayout';
import { RefinanceStepper } from '../components/features/RefinanceStepper';
import { RefinanceCta } from '../components/features/RefinanceCta';
import { FormContext } from '../store/refinance/RefinanceContext';
import { RefinanceResult } from '../components/features/RefinanceResult';
import { Loader } from '../components/shared/Loader';

export const Home = () => {
	const { data, isLoading } = useContext(FormContext);
    return (
        <BaseLayout>
            <Grid>
							<Column cols={[12, null, null, 5]}>
								<RefinanceCta />
							</Column>
							<Column cols={[12, null, null, 7]}>
								{data ? <RefinanceResult data={data} /> : null }
								<div hidden={!!data}>
								<RefinanceStepper />
								</div>
							</Column>
							<Loader isLoading={isLoading} />
            </Grid>
        </BaseLayout>
    );
};
